import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { Reveal, MaskedLine } from "../components/site/Reveal";
import { Marquee } from "../components/site/Marquee";
import { Seo } from "../components/site/Seo";
import { ASSETS, MERCH } from "../lib/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Merch() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const join = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/droplist`, { email });
      toast.success(
        data.status === "already_in"
          ? "You're already on the drop list."
          : "You're in. We'll hit you when the drop lands.",
      );
      setEmail("");
    } catch {
      toast.error("Enter a valid email and try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="merch-page" className="pt-16">
      <Seo
        title="Hyrox Ninja × NinjAthlete Merch — Black & White 214 Drop | HyroxNinja"
        description="The Hyrox Ninja × NinjAthlete line: strictly black & white 214 city-code tees, the shuriken hoodie, race card long sleeve and more. Coming soon — join the drop list."
      />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-20 pb-10">
        <div className="flex items-center gap-4 mb-5">
          <span className="font-head font-black uppercase text-2xl tracking-tight leading-none">
            HYROX<span className="text-volt">NINJA</span>
          </span>
          <span className="font-head font-black text-2xl text-white">×</span>
          <img src={ASSETS.ninjathleteLogo} alt="NinjAthlete" className="h-10 bg-white px-2 py-1 object-contain" />
        </div>
        <h1 className="font-head font-black uppercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl mb-6">
          <MaskedLine delay={0.1}>The Co-Branded</MaskedLine>
          <MaskedLine delay={0.25} className="text-outline">214 Drop</MaskedLine>
        </h1>
        <p className="text-zinc-400 max-w-2xl leading-relaxed mb-6">
          Hyrox Ninja × NinjAthlete — strictly black & white, the way both
          brands wear it. City-code streetwear meets race-day performance
          gear. The full line is in production — join the drop list and be
          first when it lands.
        </p>
        <form onSubmit={join} className="flex flex-col sm:flex-row gap-3 max-w-lg" data-testid="droplist-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="YOUR@EMAIL.COM"
            className="volt-input bw"
            data-testid="droplist-email-input"
          />
          <button type="submit" disabled={busy} className="btn-mono whitespace-nowrap disabled:opacity-60" data-testid="droplist-submit-button">
            <Bell size={16} /> {busy ? "Joining..." : "Notify Me"}
          </button>
        </form>
      </section>

      <Marquee mono items={["COMING SOON", "HYROX NINJA × NINJATHLETE", "214 DROP", "BLACK & WHITE ONLY", "HYROX NINJA"]} />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {MERCH.map((m, i) => (
            <Reveal key={m.id} delay={Math.min(i * 0.06, 0.25)}>
              <div className="merch-card bw group" data-testid={`merch-card-${m.id}`}>
                <div className="relative overflow-hidden aspect-square">
                  <img src={m.img} alt={m.name} className="w-full h-full object-cover" />
                  <span className="absolute top-4 left-4 font-mono2 text-[10px] uppercase tracking-[0.25em] bg-white text-black px-3 py-1">
                    Coming Soon
                  </span>
                </div>
                <div className="p-5 flex items-start justify-between gap-3">
                  <div>
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-zinc-400 mb-1">{m.tag}</p>
                    <h3 className="font-head font-bold uppercase text-xl leading-tight">{m.name}</h3>
                  </div>
                  <p className="font-mono2 text-xs text-zinc-500 uppercase whitespace-nowrap mt-1">TBA</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="text-zinc-500 text-xs font-mono2 uppercase tracking-wider mt-10">
          Display only — pricing and store link announced at drop. NinjAthlete wordmark used with permission.
        </p>
      </section>
    </div>
  );
}
